/**
 * <video-reels>: carrossel de vídeos verticais (Swiper do vendor.js, loop centralizado).
 * Toca só o vídeo do centro, cria o <video> sob demanda (a partir do <template>)
 * e descarta os que ficam longe para poupar memória. Pausa fora da tela.
 */
(function () {
  "use strict";

  if (customElements.get("video-reels")) return;
  if (!window.EssenceBaseComponent) return;

  /** Mesmo breakpoint único do <swiper-slider> (celular < 768 ≤ computador). */
  var DESKTOP_BP = 768;

  class VideoReels extends window.EssenceBaseComponent {
    get observerRootMargin() { return "200px 0px"; }

    init() {
      var signal = this.__tdController.signal;
      this.setMuted(true);

      this.addEventListener("click", (event) => this.onClick(event), { signal });

      var swiperEl = this.querySelector(".swiper");
      var layout = theme.sliderLayout(swiperEl);
      var autoplaySeconds = Number(this.dataset.autoplay);
      this.__autoplay = autoplaySeconds > 0;
      var breakpoints = {};
      breakpoints[0] = layout.mobile;
      breakpoints[DESKTOP_BP] = layout.desktop;

      // destroy(true, true) apaga o style do .swiper (onde ficam as 4 variáveis);
      // restaurado no destroy() para quando a seção é movida no editor.
      this.__swiperEl = swiperEl;
      this.__swiperStyle = swiperEl.getAttribute("style");
      this.swiper = new Swiper(swiperEl, {
        loop: true,
        centeredSlides: true,
        speed: Number(this.dataset.speed),
        preventClicks: false,
        grabCursor: true,
        breakpoints: breakpoints,
        autoplay: autoplaySeconds > 0
          ? { delay: autoplaySeconds * 1000, disableOnInteraction: false }
          : false,
        mousewheel: { enabled: true, forceToAxis: true },
      });

      // transitionEnd, não slideChangeTransitionEnd: quando o loop reordena os slides no meio do
      // arrasto, o Swiper não emite slideChangeTransitionEnd e o vídeo novo não tocava.
      this.swiper.on("transitionEnd", () => this.playActiveVideo());
      // iPhone: vídeo com som só baixa e toca se o play acontecer dentro de um toque. O Swiper troca
      // o slide ainda dentro do "soltar o dedo", então o play sai no slideChange, não no fim da animação.
      this.swiper.on("slideChange", () => {
        if (this.__userStarted) this.playActiveVideo();
      });
      this.observeViewport();
    }

    /** Toca/pausa conforme a seção entra/sai da tela (o observer da base só dispara o init). */
    observeViewport() {
      if (window.Shopify && window.Shopify.designMode) {
        this.setInView(true);
        return;
      }
      this.__viewObserver = new IntersectionObserver(
        (entries) => this.setInView(entries.some((entry) => entry.isIntersecting)),
        { rootMargin: "200px 0px" }
      );
      this.__viewObserver.observe(this);
    }

    setInView(inView) {
      if (this.__inView === inView) return;
      this.__inView = inView;

      if (inView) {
        this.playActiveVideo();
        if (this.swiper && this.__autoplay) this.swiper.autoplay.start();
        return;
      }
      this.pauseVideos(null, true);
      if (this.swiper && this.swiper.autoplay) this.swiper.autoplay.stop();
    }

    onClick(event) {
      if (event.target.closest(".video-reels__mute")) {
        event.preventDefault();
        this.setMuted(!this.isMuted());
        return;
      }
      if (event.target.closest("a")) return;

      var media = event.target.closest(".video-reels__media");
      if (!media) return;
      event.preventDefault();

      var realIndex = this.realIndexOf(media);
      var isSide = this.swiper && realIndex >= 0 && realIndex !== this.swiper.realIndex;
      var video = this.getVideo(media);
      if (!video) return;
      // Carregando (spinner) conta como "quer tocar": o toque insiste no play em vez de pausar.
      var loading = video.closest(".video-reels__card").getAttribute("data-loading") === "true";
      if (!isSide && !video.paused && !loading) {
        this.__userStarted = false;
        this.pauseVideos();
        return;
      }

      // Play pelo toque já sai com som (o toque do cliente libera o som no navegador).
      // O vídeo do lado começa aqui mesmo, ainda dentro do toque, e vai para o centro.
      // Depois do primeiro play, o vídeo que chega ao centro toca sozinho (até o cliente pausar).
      this.__userStarted = true;
      this.setMuted(false);
      this.activateVideo(video);
      if (isSide) {
        this.__forcePlay = true;
        this.swiper.slideToLoop(realIndex);
      }
    }

    realIndexOf(el) {
      var slide = el.closest(".swiper-slide");
      var value = slide ? slide.getAttribute("data-swiper-slide-index") : null;
      return value == null ? -1 : Number(value);
    }

    /** Pausa todos (menos keepVideo) e remove os <video> a mais de 1 slide do ativo. */
    pauseVideos(keepVideo, removeAll) {
      var slides = this.swiper ? this.swiper.slides : [];
      var total = slides.length;
      var activeIndex = this.swiper ? this.swiper.activeIndex : 0;

      this.querySelectorAll(".video-reels__media > video").forEach((video) => {
        if (video === keepVideo) return;
        var card = video.closest(".video-reels__card");
        card.setAttribute("data-playing", "false");
        card.setAttribute("data-loading", "false");
        video.pause();

        if (removeAll || !total) {
          video.remove();
          return;
        }
        var index = Array.prototype.indexOf.call(slides, video.closest(".swiper-slide"));
        var distance = index < 0
          ? Infinity
          : Math.min(Math.abs(index - activeIndex), total - Math.abs(index - activeIndex));
        if (distance > 1) video.remove();
      });
    }

    getVideo(media) {
      var existing = media.querySelector(":scope > video");
      if (existing) return existing;

      var template = media.querySelector("template");
      var source = template && template.content.querySelector("video");
      if (!source) return null;

      var video = source.cloneNode(true);
      video.loop = true;
      video.muted = this.isMuted();
      video.playsInline = true;
      video.preload = "metadata";
      // Spinner enquanto o vídeo que deve tocar ainda não tem imagem (no iPhone ele só baixa no play).
      var card = media.closest(".video-reels__card");
      var signal = this.__tdController.signal;
      var setLoading = function (value) { card.setAttribute("data-loading", String(value)); };
      video.addEventListener("waiting", function () { if (!video.paused) setLoading(true); }, { signal });
      video.addEventListener("playing", function () { setLoading(false); }, { signal });
      video.addEventListener("pause", function () { setLoading(false); }, { signal });
      var poster = media.querySelector(".video-reels__poster");
      if (poster) poster.after(video);
      else media.prepend(video);
      return video;
    }

    playActiveVideo() {
      if (!this.__inView || !this.swiper) return;
      var forcePlay = this.__forcePlay;
      this.__forcePlay = false;

      // Pelo realIndex: no loop o Swiper reordena os slides e o activeIndex pode apontar para o anterior.
      var realIndex = this.swiper.realIndex;
      var slide = Array.prototype.find.call(this.swiper.slides, (el) => this.realIndexOf(el) === realIndex);
      var media = slide && slide.querySelector(".video-reels__media");
      if (!media || (!forcePlay && !this.__userStarted && media.dataset.autoplay !== "true")) {
        this.pauseVideos();
        return;
      }
      this.activateVideo(this.getVideo(media));
    }

    activateVideo(video) {
      if (!video) return;
      this.pauseVideos(video);
      var card = video.closest(".video-reels__card");
      card.setAttribute("data-playing", "true");
      // HAVE_FUTURE_DATA (3): já tem o bastante para começar; abaixo disso mostra o spinner.
      card.setAttribute("data-loading", String(video.readyState < 3));
      this.playVideo(video);
      this.watchStuck(video);
    }

    /**
     * Rede de segurança: se em 3s o vídeo com som nem começou a baixar (readyState 0 — o iPhone
     * bloqueou), toca mudo, que o navegador sempre permite, em vez de girar o spinner para sempre.
     */
    watchStuck(video) {
      window.clearTimeout(this.__stuckTimer);
      if (this.isMuted()) return;
      this.__stuckTimer = window.setTimeout(() => {
        if (!video.isConnected || video.paused || video.readyState > 0 || this.isMuted()) return;
        this.setMuted(true);
        this.playVideo(video);
      }, 3000);
    }

    /**
     * play() rejeita quando outro vídeo assume antes de começar (pause no meio) — esperado.
     * Se o navegador recusar o som (NotAllowedError), toca mudo.
     */
    playVideo(video) {
      video.muted = this.isMuted();
      video.play().catch((error) => {
        if (!error || error.name !== "NotAllowedError" || video.muted) return;
        this.setMuted(true);
        video.play().catch(function () {});
      });
    }

    isMuted() {
      return this.__muted !== false;
    }

    setMuted(muted) {
      this.__muted = Boolean(muted);
      this.dataset.muted = String(this.__muted);
      var label = this.__muted ? this.dataset.labelUnmute : this.dataset.labelMute;
      this.querySelectorAll(".video-reels__mute").forEach(function (btn) {
        btn.setAttribute("aria-label", label);
      });
      this.querySelectorAll(".video-reels__media > video").forEach((video) => {
        video.muted = this.__muted;
      });
    }

    onEditorBlockSelect(event) {
      if (!this.swiper || !event.detail || !event.detail.blockId) return;
      var slide = this.querySelector('.swiper-slide[data-block-id="' + event.detail.blockId + '"]');
      var realIndex = slide ? this.realIndexOf(slide) : -1;
      if (realIndex < 0) return;
      if (this.swiper.autoplay) this.swiper.autoplay.stop();
      this.swiper.slideToLoop(realIndex, 500);
    }

    onEditorBlockDeselect() {
      if (this.swiper && this.__autoplay) this.swiper.autoplay.start();
    }

    destroy() {
      window.clearTimeout(this.__stuckTimer);
      if (this.__viewObserver) {
        this.__viewObserver.disconnect();
        this.__viewObserver = null;
      }
      this.pauseVideos(null, true);
      if (this.swiper) this.swiper.destroy(true, true);
      this.swiper = null;
      if (this.__swiperEl && this.__swiperStyle != null) {
        this.__swiperEl.setAttribute("style", this.__swiperStyle);
      }
      this.__inView = undefined;
    }
  }

  customElements.define("video-reels", VideoReels);
})();
